import { ExclamationCircleIcon } from "@heroicons/react/solid";
import PropTypes from "prop-types";

export default function Checkbox({
  id,
  name,
  label,
  description,
  required,
  disabled,
  error,
  checked,
  onChange,
  inputProps,
}) {
  const hasDescription = Boolean(description);
  const hasError = Boolean(error);

  return (
    <div className="relative flex items-start">
      <div className="flex items-center h-5">
        <input
          id={id}
          name={name}
          value={checked}
          onChange={onChange}
          required={required}
          disabled={disabled}
          aria-describedby={id}
          type="checkbox"
          className={`${
            hasError
              ? "border-none ring ring-danger focus:ring focus:ring-danger rounded"
              : "focus:purple h-4 w-4 text-purple border-gray-300 rounded"
          }`}
          {...inputProps}
        />
      </div>
      <div className="ml-2 text-sm">
        <label
          htmlFor={id}
          className="text-gray-700"
          data-testid="checkbox-label"
        >
          {label}
        </label>
        {hasDescription ? (
          <p data-testid="description-test" className="text-gray-500">
            {description}
          </p>
        ) : null}
        {hasError ? (
          <div
            className="mt-xs flex flex-row gap-xs"
            data-testid="error-text-test"
          >
            <ExclamationCircleIcon
              className="h-input-icon text-danger"
              aria-hidden="true"
            />
            <div className="gn-text-sm text-danger">{error}</div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  description: PropTypes.string,
  inputProps: PropTypes.shape({
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
  }),
};

Checkbox.defaultProps = {
  id: undefined,
  name: undefined,
  required: undefined,
  disabled: undefined,
  error: undefined,
  description: undefined,
  checked: undefined,
  onChange: () => {},
  inputProps: {
    onKeyUp: () => {},
    onBlur: () => {},
  },
};
